// Backlog 205 (Storm 2026-10-22 21:04): an open console keeps running the old
// build after a deploy until it is reloaded. The console now checks the live
// index.html every few minutes and, if it names a different main bundle, shows
// a strip asking the agent to refresh between calls. It never reloads itself.
// Pure helpers so scripts/verify-new-version.mjs can prove the rules.

export const CHECK_MS = 5 * 60 * 1000;

// The main bundle path in a page: "/assets/index-<hash>.js", or null.
export function bundleFromHtml(html) {
  const m = /<script[^>]*\bsrc="(\/assets\/index-[A-Za-z0-9_-]+\.js)"/.exec(String(html || ''));
  return m ? m[1] : null;
}

// The bundle this page is running, from the loaded script tags.
export function runningBundle(doc) {
  try {
    const s = [...(doc?.querySelectorAll?.('script[src]') || [])]
      .map(e => e.getAttribute('src') || '')
      .find(src => /\/assets\/index-[A-Za-z0-9_-]+\.js$/.test(src));
    if (!s) return null;
    const m = /(\/assets\/index-[A-Za-z0-9_-]+\.js)$/.exec(s);
    return m ? m[1] : null;
  } catch { return null; }
}

// New version only when both are known and differ (unknown never nags).
export function isNewVersion(running, live) {
  return !!running && !!live && running !== live;
}

// Show the strip only when it cannot interrupt work: not on a call, not
// ringing, not in wrap-up. The check itself runs regardless.
export function mayShowStrip({ newVersion, callActive, incomingContact, wrapContext }) {
  return !!newVersion && !callActive && !incomingContact && !wrapContext;
}

export const STRIP_TEXT = 'A new version of the console is ready. Refresh when you’re between calls.';
